<template>
    <div class="onwork">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h4 class="title1">课后练习综合解决方案</h4>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item1_list">
                        <img :src="'/static/img/product_onwork/chanpin7_0'+(index+1)+'.png'" alt="">
                        <div class="title">{{x.title}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            item1_list:[
                {title:"打卡提醒"},
                {title:"线上提交作业"},
                {title:"学员高频练习"},
                {title:"老师家长互评"},
                {title:"作业展示留存"},
                {title:"养成良好习惯"},
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
            this.$parent.$refs.openPop.openDialog(title,type);
        }
    }
}
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 480px;
    margin-top: 80px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/product_onwork/chanpin7_banner.jpg") no-repeat center;

    .banner-center {
        height: 100%;
        position: relative;
    }

    .banner-info {
        position: absolute;
        bottom: 120px;
        left:50px;
        text-align: left;
    }
}

.item_1 {
        padding-top:160px;
        padding-bottom:160px;

        .item-contents {
            margin-top: 60px;

            ul {
                width: 1020px;
                height: 580px;
                margin:0 auto;
                padding-top: 20px;
                padding-bottom: 20px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content: space-between;

                li {
                    width: 300px;
                    height: 240px;
                    padding: 40px 0;
                    background: #F9FCFF;
                    border: 1px solid rgba(89, 112, 196, 0.2);

                    img {
                        width: 120px;
                        height: 120px;
                        margin: 0 auto 10px;
                    }

                    .title {
                        text-align: center;
                        color: #1E1E1E;
                        font-size: 20px;
                    }


                    &:hover {
                        transition: 0.5s;
                        background: #FFFFFF;
                        margin-top:-10px;
                        border:none;
                        box-shadow: 0px 2px 30px 0px rgba(191, 202, 214, 0.5);
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/product_onwork.vue